var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHamburgerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26H28V23.6667H10V26ZM10 20.1667H28V17.8333H10V20.1667ZM10 12V14.3333H28V12H10Z",
    fill: "black",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 4,
    fill: "#E74851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerActive);
export default __webpack_public_path__ + "static/media/icon_hamburger_active.e5306a5138aa0d268a5c6abcdfb0033c.svg";
export { ForwardRef as ReactComponent };